import md5 from "md5";

export default function hashWithMd5(value) {
  if (value) {
    return md5(String(value))
  }
  return null
}
